import React from "react"
import { FetchPriority, PartImage } from "@ncs/web-legos/components"
import { SerializedStyles } from "@emotion/react"

import { spin360Container } from "./styles"
import { useScreenSizeMatch } from "@ncs/web-legos/util"
import { PublishedAsset } from "@ncs/ncs-api/src/portal-apps/point-of-sale/types"
import { Spin360 } from "~/shared-components/Spin360"

type AssetRendererProps = {
	asset: PublishedAsset
	isLoading: boolean
	onExpand?: (asset: PublishedAsset) => void
	partImageStyle?: SerializedStyles
	spinerStyle?: SerializedStyles
	spinerMaxWidth?: number
	fetchpriority?: FetchPriority
}

const AssetRenderer: React.FC<AssetRendererProps> = ({
	asset,
	isLoading = false,
	onExpand,
	partImageStyle,
	spinerStyle,
	spinerMaxWidth = 320,
	fetchpriority = "auto",
}) => {
	const isMobile = useScreenSizeMatch("sm")
	const spinerWidth = isMobile ? 320 : spinerMaxWidth
	const handleExpand = () => {
		if (onExpand) {
			onExpand(asset)
		}
	}

	if (
		asset.assetRole === "360" &&
		asset.jsonMetadata &&
		asset.assetUrl &&
		asset.jsonMetadata.columns &&
		asset.jsonMetadata.rows
	) {
		const meta = asset.jsonMetadata
		return (
			<button css={[spin360Container, spinerStyle]} type="button">
				<Spin360
					imageUrl={asset.assetUrl}
					meta={meta}
					width={spinerWidth}
					autoplay
					fps={6}
					dragSensitivity={6}
					blurUntilLoaded
					showSkeleton={true}
					ariaLabel={`Spin of part ${meta?.partNumber}`}
					onClick={handleExpand}
				/>
			</button>
		)
	}

	if (asset.assetUrl) {
		return (
			<figure>
				<PartImage
					skeleton={{
						size: 320,
						containerProps: {
							height: 20,
						},
					}}
					src={asset.assetUrl}
					alt={asset.description}
					isLoading={isLoading}
					onClick={handleExpand}
					css={partImageStyle}
					fetchpriority={fetchpriority}
				/>
			</figure>
		)
	}
	return (
		<div>
			<PartImage
				skeleton={{
					size: 320,
					containerProps: {
						height: 20,
					},
				}}
				isLoading={isLoading}
				onClick={handleExpand}
				css={partImageStyle}
			/>
		</div>
	)
}

export default AssetRenderer
